import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { departments, loadDepartments, departmentsOf, departmentChoices, departmentById } from '../../utils/departments.js';

// "Handbal" in the colour of the afdeling (with its logo when it has one), on news,
// agenda items, documents and in the structure
export function DepartmentLabel({ department }) {
  if (!department) return null;
  return (
    <span title={`Afdeling ${department.name}`} style={`display:inline-flex;align-items:center;gap:5px;font-size:11px;font-weight:600;text-transform:none;letter-spacing:normal;padding:2px 8px 2px 6px;border-radius:10px;white-space:nowrap;max-width:100%;overflow:hidden;text-overflow:ellipsis;color:${department.color};background:color-mix(in srgb, ${department.color} 12%, transparent);border:1px solid color-mix(in srgb, ${department.color} 35%, transparent)`}>
      {department.logo_path
        ? <img src={department.logo_path} alt="" style="width:14px;height:14px;object-fit:contain;border-radius:3px" />
        : <span aria-hidden="true" style={`width:8px;height:8px;border-radius:50%;background:${department.color};flex-shrink:0`} />}
      {department.name}
    </span>
  );
}

// The labels of the departments a set of targets ({ type, id }) is in; nothing when the
// club has fewer than two departments. wrap: style of a box around them (only drawn
// when there is a label)
export default function DepartmentLabels({ targets, wrap }) {
  // Reading the signal re-renders this label once the departments are in
  void departments.value;
  useEffect(() => { loadDepartments(); }, []);
  const list = departmentsOf(targets);
  if (!list.length) return null;
  const labels = list.map(d => <DepartmentLabel key={d.id} department={d} />);
  return wrap ? <div style={wrap}>{labels}</div> : <>{labels}</>;
}

// The label of one department by id (a process runs in one); nothing when the club has
// fewer than two. wrap: style of a box around it (only drawn when there is a label)
export function DepartmentLabelById({ id, wrap }) {
  void departments.value;
  useEffect(() => { loadDepartments(); }, []);
  const department = id != null && departmentChoices().length ? departmentById(id) : null;
  if (!department) return null;
  return wrap ? <div style={wrap}><DepartmentLabel department={department} /></div> : <DepartmentLabel department={department} />;
}
